// extracted by mini-css-extract-plugin
export var filterIncDec = "_ek-0";
export var leftBorder = "_ek-1";
export var rightBorder = "_ek-2";
export var stringInput = "_ek-3";